import React from "react";
import { sAddCustomer, sPhonePrefix } from "../constants/strings";
import { Stack } from "@mui/material";
import { GenericInput } from "../components/input/GenericInput";
import { FormWrapper } from "../components/styled/StyledComponents";
import { FormButton } from "../components/buttons/FormButton";
import { GenericSwitch } from "../components/elements/Switch";
import useForm from "../hooks/useForm";
import { GenericSelect } from "../components/select/GenericSelect";
import { EditableTable } from "../components/tables/EditableTable";

export const OrderForm = () => {
  const { form, onChange, updateFormValue, updateFormValues } = useForm({});
  return (
    <form>
      <FormWrapper>
        <Stack spacing={3}>
          {/* Name */}
          <GenericInput label="Username / Email" required />

          <GenericSelect
            value={form.products}
            label="Products"
            // onChange={(value) => {
            //   updateFormValue("parent", value);
            // }}
            // options={[
            //   { value: "top-menu", label: "Top Menu" },
            //   ...topMenu?.map((category) => {
            //     return {
            //       value: category.id,
            //       label: category.category_name,
            //     };
            //   }),
            // ]}
            required
          />

          <EditableTable />

          {/* Location */}
          <GenericInput label="Location" required />

          {/* Submit */}
          <FormButton>Create Order</FormButton>
        </Stack>
      </FormWrapper>
    </form>
  );
};
